module.exports = __webpack_public_path__ + "img/cloud-sun-03.40798f06.svg";